export default {
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  apiURL: import.meta.env.VITE_ADFLOW_API_URL
};
